
import FireView from './src/FireView.vue' //火情测报


let views = {

    FireView,

};

export default views;